

import { h } from 'preact';

export default function (props) {
    var styles = props.styles;
    var rest = Object.assign({}, props);
    delete rest.styles;

    return h('svg', Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"14.5","height":"14.5"}, rest), [h('path', {"fill":"#FFF","fill-rule":"nonzero","d":"M.75 6a.75.75 0 0 1 .75.75v6c0 .138.112.25.25.25h6a.75.75 0 0 1 0 1.5h-6A1.75 1.75 0 0 1 0 12.75v-6A.75.75 0 0 1 .75 6Zm12-6c.966 0 1.75.784 1.75 1.75v6a.75.75 0 0 1-1.5 0v-6a.25.25 0 0 0-.25-.25h-6a.75.75 0 0 1 0-1.5h6Z"}, [])]);
};

        